import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { doFetch } from '../redux/api/actions';
import { GET_LOCATIONS } from '../redux/api/constants';
import MapView from './MapView';
import AudioPlayer from './AudioPlayer';

function Home() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(doFetch(GET_LOCATIONS, "locations"));
    }, [dispatch]);

    return (
        <>
            {/* Map-first interface for audio tour discovery */}
            <MapView />

            {/* Persistent audio player (Spotify-style bottom bar) */}
            <AudioPlayer />
        </>
    );
}

export default Home;
